/**
 * 日本站 - 个人 - 步骤1数据模板
 *
 * author: xiao.xu
 */

// eslint-disable-next-line no-unused-vars
import React from 'react';

import { translate } from '_common/utils/language';

import getBase from './P_BASE';

function P1_COMMON() {
  const base = getBase();
  const template = [
    {
      title: translate('jp.personal.fill'),
      subTitle: translate('jp.personal.fill.tips'),
      form: {
        firstNameTotal: base.firstName,
        firstNamePyTotal: base.firstNamePy,
        sex: base.sex,
        birthday: base.birthDay,
        countryCode: base.countryCode,
      },
    },
    {
      title: translate('jp.person.location.fill'),
      // subTitle: (
      //   <div className="warning-hint">
      //     <p>{translate('jp.verification.location.tips1')}</p>
      //     <p>{translate('jp.verification.location.tips2')}</p>
      //   </div>
      // ),
      form: {
        residence: base.residenceCode,
        postCode: base.postCode,
        addressData: base.addressData,
        street: base.street,
        location: base.locationWithTips,
        residenceType: base.residenceType,
        residenceValidity: base.residenceValidity,
      },
    },
    {
      title: translate('jp.person.job.fill'),
      form: {
        career: base.career,
        position: base.position,
        income: base.income,
        financialAssets: base.financialAssets,
      },
    },
  ];
  return template;
}

export default P1_COMMON;
